import httpRequest from "../../ajax";
import { ERROR, HIRING_SUPPORT_LOADING, HIRING_SUPPORT_SUBMIT, HIRING_SUPPORT_STATUS, HIRING_SUPPORT_CANCEL, HIRING_SUPPORT_HISTORY } from "../actionTypes";

export const submitHiringSupportRequest = (dispatch, payload) => {
  dispatch({ type: HIRING_SUPPORT_LOADING, payload: { submitting: true } });

  return httpRequest("post", "/hiring-support/request", payload)
    .then(({ data }) => {
      if (data?.status) {
        dispatch({ type: HIRING_SUPPORT_SUBMIT, payload: data.data });
      } else {
        dispatch({ type: ERROR, payload: data });
      }
      return data;
    })
    .catch((error) => {
      dispatch({ type: ERROR, payload: error?.response?.data || error });
      return Promise.reject(error);
    })
    .finally(() => {
      dispatch({ type: HIRING_SUPPORT_LOADING, payload: { submitting: false } });
    });
};

export const getHiringSupportStatus = (dispatch) => {
  dispatch({ type: HIRING_SUPPORT_LOADING, payload: { loadingStatus: true } });

  return httpRequest("get", "/hiring-support/status", {})
    .then(({ data }) => {
      if (data?.status) {
        dispatch({ type: HIRING_SUPPORT_STATUS, payload: data.data });
      } else {
        dispatch({ type: HIRING_SUPPORT_STATUS, payload: null });
      }
      return data;
    })
    .catch((error) => {
      dispatch({ type: ERROR, payload: error?.response?.data || error });
      return Promise.reject(error);
    })
    .finally(() => {
      dispatch({ type: HIRING_SUPPORT_LOADING, payload: { loadingStatus: false } });
    });
};

export const cancelHiringSupportRequest = (dispatch, requestId) => {
  dispatch({ type: HIRING_SUPPORT_LOADING, payload: { cancelling: true } });

  return httpRequest("patch", `/hiring-support/${requestId}/cancel`, {})
    .then(({ data }) => {
      if (data?.status) {
        dispatch({ type: HIRING_SUPPORT_CANCEL, payload: data.data });
      } else {
        dispatch({ type: ERROR, payload: data });
      }
      return data;
    })
    .catch((error) => {
      dispatch({ type: ERROR, payload: error?.response?.data || error });
      return Promise.reject(error);
    })
    .finally(() => {
      dispatch({ type: HIRING_SUPPORT_LOADING, payload: { cancelling: false } });
    });
};

export const getHiringSupportHistory = (dispatch) => {
  dispatch({ type: HIRING_SUPPORT_LOADING, payload: { loadingHistory: true } });

  return httpRequest("get", "/hiring-support/history", {})
    .then(({ data }) => {
      if (data?.status) {
        dispatch({ type: HIRING_SUPPORT_HISTORY, payload: data.data });
      } else {
        dispatch({ type: HIRING_SUPPORT_HISTORY, payload: [] });
      }
      return data;
    })
    .catch((error) => {
      dispatch({ type: ERROR, payload: error?.response?.data || error });
      return Promise.reject(error);
    })
    .finally(() => {
      dispatch({ type: HIRING_SUPPORT_LOADING, payload: { loadingHistory: false } });
    });
};
